export class PromiseLoaderCache<T> {
	private idToImagePromiseMap = new Map<string, Promise<T>>();
	private idToImageMap = new Map<string, T>();
	private subscriptions: Function[] = [];

	addSubscription(callback: Function) {
		this.subscriptions.push(callback);
	}

	removeSubscription(callback: Function) {
		this.subscriptions = this.subscriptions.filter((cb) => cb !== callback);
	}

	notifyAllSubscriptions() {
		this.subscriptions.forEach((cb) => cb());
	}

	hasPromise(id: string) {
		return this.idToImagePromiseMap.has(id);
	}

	getPromise(id: string) {
		return this.idToImagePromiseMap.get(id);
	}

	setPromise(id: string, promise: Promise<T>) {
		this.idToImagePromiseMap.set(id, promise);
		promise.then((image) => {
			this.idToImageMap.set(id, image);
			this.idToImagePromiseMap.delete(id);
			this.notifyAllSubscriptions();
		});
	}

	hasImage(id: string) {
		return this.idToImageMap.has(id);
	}

	getImage(id: string) {
		return this.idToImageMap.get(id);
	}

	getWithFallback(id: string, loadImageAsync: () => Promise<T>): T | undefined {
		if (this.hasImage(id)) {
			return this.getImage(id)!;
		}

		if (this.hasPromise(id)) {
			// This image is currently loading
			return undefined;
		}

		this.setPromise(id, loadImageAsync());

		return undefined;
	}
}
